import { render, staticRenderFns } from "./CourseGroupCard.vue?vue&type=template&id=3866217e&scoped=true&"
import script from "./CourseGroupCard.vue?vue&type=script&lang=js&"
export * from "./CourseGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseGroupCard.vue?vue&type=style&index=0&id=3866217e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866217e",
  null
  
)

export default component.exports